import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { ReactSVG } from 'react-svg'

import helperFunction from '../tmoUtilities/helpers'
import { SORT_DIRECTION } from '../tmoUtilities/constants'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'

import style from './DynamicList.module.css'

function DynamicList({
  className,
  headerNameListItemMap,
  listItems,
  onSort,
  sortDirection,
  type,
  verticalScroll = false,
  sortIcon
}) {
  const [sortedList, setSortedList] = useState(listItems)
  const [sortedColumn, setSortedColumn] = useState()
  const handleSorting = (object) => {
    sortDirection && onSort(object)
    if (object.sortable) {
      object.sortDirection =
        object.sortDirection === SORT_DIRECTION.ASC
          ? SORT_DIRECTION.DESC
          : SORT_DIRECTION.ASC
      const listItemKey = object.listItemKey
      setSortedColumn(listItemKey)
      const list = [...listItems]
      helperFunction.sortList(list, { listItemKey }, object.sortDirection)
      setSortedList(list)
    }
  }

  useEffect(() => {
    setSortedList(listItems)
  }, [listItems])

  const handleKeyDown = (event, object) => {
    if (event.key === 'Enter') {
      handleSorting(object)
    }
  }

  return (
    <div
      tabIndex={0}
      className={classNames(
        style.container,
        verticalScroll && style.vertical_scroll
      )}
    >
      <table
        className={classNames(
          style.table,
          type === 'primary' && style.primary,
          className
        )}
      >
        <thead>
          <tr>
            {headerNameListItemMap.map((object, index) => (
              <th
                key={index}
                onClick={() => handleSorting(object)}
                className={classNames(style.column, style.header)}
                scope='col'
                aria-sort={
                  object.sortable
                    ? object.sortDirection === SORT_DIRECTION.ASC
                      ? 'ascending'
                      : 'descending'
                    : undefined
                }
                tabIndex={object.sortable ? 0 : -1}
                onKeyDown={
                  object.sortable ? (e) => handleKeyDown(e, object) : undefined
                }
              >
                {type === 'primary' ? (
                  <div className={style.sortable_header}>
                    {object.headerDisplayName || object.listItemKey}
                    {object.sortable && (
                      <ReactSVG
                        className={
                          sortedColumn === object.listItemKey
                            ? object.sortDirection === 'ASC'
                              ? style.asc_order
                              : style.dsc_order
                            : null
                        }
                        src={sortIcon}
                      />
                    )}
                  </div>
                ) : (
                  <React.Fragment>
                    {object.headerDisplayName || object.listItemKey}
                    <span className={style.sort_icon} aria-hidden='true'>
                      {(sortDirection || object.sortable) &&
                        ((sortDirection || object.sortDirection) === 'ASC' ? (
                          <FaCaretDown />
                        ) : (
                          <FaCaretUp />
                        ))}
                    </span>
                  </React.Fragment>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {sortedList.map((item, index) => (
            <tr key={index} className={style.item}>
              {headerNameListItemMap.map((object, index) => (
                <td
                  key={index}
                  className={classNames(style.column, object.columnClass)}
                >
                  {object.render?.(item) || item[object.listItemKey]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default DynamicList
